import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
import i18n from './i18n'
import { abilitiesPlugin } from '@casl/vue'
import { AbilityBuilder } from '@casl/ability'

import '@/directives'
import '@/filters/'
import '@/sass/main.scss'

Vue.config.productionTip = false

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })
Vue.use(abilitiesPlugin, AbilityBuilder.define({
  /* Surcharge de la facon dont le type d'objet est decouvert.
  * Comme cela on peut passer des objets literral sans construteur
  * et tester les ACL coté front sur des objets au lieu de string.
  * Les conditions pourront de ce fait etre resolu coté front
  */
  subjectName (subject) {
    if (!subject || typeof subject === 'string') {
      return subject
    }
    // Surcharge ici
    let Type
    if (subject.modelName) {
      Type = { modelName: subject.modelName }
    } else {
      Type = typeof subject === 'object' ? subject.constructor : subject
    }
    return Type.modelName || Type.name
  }
}, () => {}))

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
})

// Connection socket websocket
store.commit('notification/CONNECTION_SERVER')
store.dispatch('auth/AUTOLOGIN').finally(() => {
  app.$mount('#app')
})
